import $ from 'jquery';

const dropdownoverlay = $('.dropdownselect .dropdownoverlay');

$('.dropdownselect').click(function () {
    if (dropdownoverlay.is(':visible')) {
        $('.dropdownoverlay').hide();
    } else {
        $('.dropdownoverlay').hide();
        dropdownoverlay.show();
    }
    return false;
});
$('.dropdownoverlay h2').click(function (event) {
    event.preventDefault();
    return false;
});
$(document).click(function () {
    $('.dropdownoverlay').hide();
});
$('.dropdownselect .dropdownoverlay a').click(function (event) {
    const a = $(this);
    const form = $('.dropdownselect').parents('form');
    if (form.length) {
        event.preventDefault();
        const saisonId = a.data('saisonid');
        const ligaName = a.data('liganame');
        $('#saisonId').val(saisonId);
        if (form.data("auto-submit")) {
            form.submit();
        } else {
            $('.dropdownselect .label').html(ligaName);
            a.removeClass("clicked");
            $('.dropdownoverlay').hide();
            $(window).scrollTop(0);
        }
        return false;
    } else {
        window.location = $(this).attr('href');
        event.preventDefault();
        return false;
    }
});
